import classNames from "classnames"
import { Button } from "../../../../components/Button"
import { useTextStorage } from "../../../../hooks"
import {
  pricesVerticalDecor,
  services3Decor1,
  services3Decor2,
} from "../../../../assets/images"
import "./PricesSection.scss"
import { useNavigate } from "react-router-dom"

export const PricesSection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const handleButtonClick = () => {
    navigate("/#connect")
  }

  return (
    <div className="prices-section">
      <div className="prices-section--texts">
        <h2>{ts.pages.home.pricesSection.title}</h2>
        <p>{ts.pages.home.pricesSection.text}</p>
      </div>
      <div className="prices-section--cards-container">
        {ts.pages.home.pricesSection.cards.map((card, index) => (
          <div
            key={card.title}
            className={classNames("prices-section--card", `bg-${index}`)}
          >
            {index === 0 && (
              <img
                src={pricesVerticalDecor}
                alt="prices-vertical-decor"
                className="prices-vertical-decor"
              />
            )}
            {index === 0 && (
              <img
                src={services3Decor1}
                alt="prices-dots-decor"
                className="prices-dots-decor"
              />
            )}
            {index === 2 && (
              <img
                src={services3Decor2}
                alt="prices-horizontal-decor"
                className="prices-horizontal-decor"
              />
            )}
            <span className="prices-section--card--top-texts">
              <h3>
                {card.title.split(" ").map((line, index) => (
                  <span key={line}>
                    {index === 1 ? (
                      <>
                        <br />
                        <span key={line}>{line}</span>
                      </>
                    ) : (
                      <span key={line}>{line}</span>
                    )}
                  </span>
                ))}
              </h3>
              <p>{card.description}</p>
            </span>
            <ul className="prices-section--card--list-items">
              {card.listItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="prices-section--card--price-and-button">
              <span className="prices-section--card--price">{card.price}</span>
              <Button text={card.buttonText} onClick={handleButtonClick} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
